import script from "./ADialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ADialog.vue?vue&type=script&lang=ts&setup=true"

import "./ADialog.vue?vue&type=style&index=0&id=4888822c&lang=scss"
import "./ADialog.vue?vue&type=style&index=1&id=4888822c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4888822c"]])

export default __exports__